import React from 'react';
import styles from './page4.scss';
import pic1 from './pic1.png';
import pic2 from './pic2.png';
import { getRem } from '../../func';

function Page4(props) {
  return (
    <div className={styles['page4']} ref={props.myRef}>
      <div className={styles['page4-main']}>
        <div className={styles['page4-child1']}>
          <div className={`${styles['page4-child1-title']} animate2-wrapper`}>
            <div r='220' g='221' b='235' className={`maskBlock animate2`} style={{ background: 'rgb(220, 221, 235)' }} />
            OUR<br />
            ADVANTAGE
          </div>

          <div className={styles['page4-child1-subTitle']}>
            <div className={styles['page4-child1-subTitle-circle']}>5</div>
            <div className={styles['page4-child1-subTitle-text']}>我们的优势 - <span style={{ color: '#32535D' }}>落地</span></div>
          </div>

          <div className={styles['page4-child1-content']}>
            <div className={styles['page4-child1-content-title']}>
              <span style={{ fontSize: getRem(16), color: '#295A57' }}>本土市场分析报告</span><br />
              LOCAL MARKET<br />
              ANALYSIS

              <div className={styles['titleNumber']}>1</div>
            </div>

            <div className={`${styles['page4-child1-content-desc']} animate1-wrapper`}>
              <div r='220' g='221' b='235' className={`maskBlock animate1`} style={{ background: 'rgb(220, 221, 235)' }} />
              我们拥有顶级的国际趋势时尚资源力量：与国外各大品牌（涵盖奢侈品牌，快消品牌，买手店，设计师品牌，版型等各品类）行业专家联手，提供“趋势+商品+买手+营销+企业管理”全方位服务与国际化创意思维。
            </div>

            <div className={styles['page4-child1-content-pic']}>
              <img src={pic1} />
            </div>

            <div className={styles['page4-icon']} style={{ position: 'absolute', bottom: '0' }}>
              <div className={styles.text}>SUITABLE</div>
              <div className={styles.area}></div>
            </div>
          </div>

        </div>

        <div className={styles['page4-child2']}>
          <div className={styles['page4-child2-pic']}>
            <img src={pic2} />
          </div>

          <div className={styles['page4-child2-content']}>
            <div className={styles['page4-child2-content-left']}>
              <div className={styles['page4-child2-content-title']}>
                <span style={{ fontSize: getRem(16), color: '#295A57' }}>大数据库支持</span><br />
                BIG DATA<br />
                SUPPORTING

                <div className={styles['titleNumber']} style={{ left: getRem(-60) }}>2</div>
              </div>
              <div className={`${styles['page4-child2-content-desc']} animate1-wrapper`}>
                <div r='220' g='221' b='235' className={`maskBlock animate1`} style={{ background: 'rgb(220, 221, 235)' }} />
                原Google人工智能工程师团队打造的知衣科技为WOW-TREND提供庞大且精细化的全球时尚市场数据库。<br /><br />
                通过对智能分类搜索、个性化推荐等人工智能技术与人类的创意相结合，让我们的用户可精准地搜索到想了解的趋势资讯及定制内容。
              </div>
            </div>

            <div className={styles['page4-child2-content-right']}>
              <div className={styles['page4-child2-content-title']}>
                <span style={{ fontSize: getRem(16), color: '#295A57' }}>资源整合</span><br />
                RESOURCES<br />
                INTEGRATION

                <div className={styles['titleNumber']} style={{ left: getRem(-55) }}>3</div>
              </div>
              <div className={`${styles['page4-child2-content-desc']} animate1-wrapper`}>
                <div r='220' g='221' b='235' className={`maskBlock animate1`} style={{ background: 'rgb(220, 221, 235)' }} />
                WOW-TREND作为连接服装产业链与各板块尖端资源的桥梁，希望通过优质资源的协作互赢，从而促进整个行业发展。<br /><br />
                我们可为零售品牌、电商品牌、ODM贴牌供应商、市场/批发商、面辅料商等领域的企业打通行业壁垒，帮助企业拓展、衔接各类所需资源渠道。
              </div>
            </div>
          </div>

          <div className={styles['page4-icon']} style={{ position: 'absolute', bottom: '0' }}>
            <div className={styles.text}>SUITABLE</div>
            <div className={styles.area}></div>
          </div>
          <div className={styles['page4-icon']} style={{ position: 'absolute', bottom: '0', left: getRem(386) }}>
            <div className={styles.text}>SUITABLE</div>
            <div className={styles.area}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page4;